<template>
	<div>
		<div class="donations-items">
			<div
				class="donation-item"
				:key="roundup.id"
				v-for="roundup in roundups"
				@click="reprocess(roundup)"
			>
				<div :class="[itemClass(roundup.payouts)]">
					<span class="date"
						>{{
							roundup.institutions[0] &&
							roundup.institutions[0].name
						}}<br />{{ toDate(roundup.created_at) }}</span
					>
					<span class="amount">{{ computeAmount(roundup) }}</span>
				</div>
				<div class="roundup-row" style="justifycontent: space-between">
					<p
						:class="{
							'roundup-error-text':
								getStripeError(roundup.payouts) &&
								!getStripeError(roundup.payouts).includes(
									'efund'
								)
						}"
						v-bind:style="{
							fontSize: '12px',
							flex: 1,
							textAlign: 'left'
						}"
					>
						{{ getRoundupType(roundup.type) }}
					</p>
					<p
						v-if="
							roundup.payouts[0] &&
							roundup.payouts[0].refund_amount
						"
						:style="{
							flex: 1,
							textAlign: 'right',
							fontSize: '12px',
							fontWeight: 600
						}"
					>
						Refunded
					</p>
				</div>
				<p
					class="roundup-error-text"
					v-if="
						getStripeError(roundup.payouts) &&
						!getStripeError(roundup.payouts).includes('efund')
					"
				>
					Click to reprocess
				</p>
				<p
					class="roundup-error-text"
					v-bind:style="{ fontSize: '12px' }"
					v-if="
						getStripeError(roundup.payouts) &&
						!getStripeError(roundup.payouts).includes('efund')
					"
				>
					Error: {{ roundup.payouts[0].stripe_error }}
				</p>
			</div>
			<div class="donation-item" v-if="roundups.length === 0">
				<p>
					No donations yet! We process RoundUps and minimum goal
					donations on the last day of each month.
				</p>
			</div>
		</div>

		<modal v-model="isSaving" size="small">
			<div v-if="errorMsg">
				<h3 style="marginright: 10px">{{ errorMsg }}</h3>
			</div>
			<div v-else class="roundup-row">
				<h3 style="marginright: 10px">Reprocessing transaction...</h3>
				<div class="loading"></div>
			</div>
		</modal>
		<modal v-model="showModal" size="small">
			<h3 style="marginright: 10px">What is this donation?</h3>
			<p>
				When you add a new card to our system, we process a $1 donation
				to your organization to confirm the card is valid. It happens
				anytime you add or change your funding source.
			</p>
		</modal>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { simpleDateFormat } from '../../../utilities'
import Modal from '../../../ui/Modal'

export default {
	name: 'donation-view',
	components: { Modal },
	computed: {
		...mapState({
			roundups: ({ roundupList }) => roundupList.items
		})
	},
	data() {
		return {
			isSaving: false,
			errorMsg: false,
			showModal: false
		}
	},
	methods: {
		...mapActions(['getRoundups', 'reprocessRoundup']),
		toDate(date) {
			return simpleDateFormat(new Date(date))
		},
		onBack() {
			this.navigate({ name: 'home' }, 'back')
		},
		getRoundupType(type) {
			switch (type) {
				case '0':
					return 'Roundup Donation'
				case '1':
					return 'Card Validation Donation'
				default:
					return 'One-Time Donation'
			}
		},
		itemClass(payout) {
			const err = this.getStripeError(payout)
			if (err.includes('efund')) {
				return 'refund'
			} else if (err) {
				return 'roundupapp-error'
			}
			return 'no-error'
		},
		getStripeError(payout) {
			return payout[0] && payout[0].stripe_error
				? payout[0].stripe_error
				: ''
		},
		computeAmount(roundup) {
			if (roundup.payouts[0] && roundup.payouts[0].refund_amount) {
				return '-$' + roundup.payouts[0].refund_amount.toFixed(2)
			}
			return '$' + roundup.amount.toFixed(2)
		},
		reprocess(roundup) {
			const payout = roundup.payouts[0]
			if (!payout) {
				return
			}
			if (payout.stripe_error == null && roundup.type == '1') {
				this.showModal = true
				return
			}
			if (payout.stripe_error == null) {
				return
			}
			if (this.itemClass(roundup.payouts) === 'refund') {
				this.showRefundModal = true
				return
			}

			this.isSaving = true
			this.errorMsg = null
			window.analytics.track('reprocess_payout')
			this.reprocessRoundup(payout.id)
				.then(() => {
					this.isSaving = false
					this.$swal('Success!')
				})
				.catch((error) => {
					this.isSaving = false
					this.errorMsg = true
					this.$swal(error.message)
				})
		}
	},
	mounted() {
		this.getRoundups()
	}
}
</script>

<style lang="scss">
.donations-items {
	background: $white;
	margin: 10px -25px 0px;
	position: relative;
	padding: 10px 20px 20px;
	z-index: 10;
	border-radius: 14px;
	box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.15);

	@media screen and (max-width: 480px) {
		margin-left: -15px;
		margin-right: -15px;
	}
	.donation-item {
		padding: 20px 10px;
		border-bottom: 1px solid $light-grey;
		cursor: pointer;
		text-decoration: none;
		color: $charcoal !important;

		&:last-child {
			border-bottom: 0px;
		}
		.date {
			flex-grow: 1;
			color: $charcoal !important;
		}
		.amount {
			flex-grow: 0;
			color: $charcoal !important;
		}
		.roundupapp-error {
			display: flex;
			flex: 1;
			.date,
			.amount {
				color: red !important;
			}
		}
		.roundup-error-text {
			color: red !important;
		}
		.no-error {
			display: flex;
			flex: 1;
		}
		p {
			text-align: center;
			padding: 0;
			margin: 0;
		}
	}
	.settings-section {
		margin-bottom: 20px;
	}
}
</style>
